import { ClassKey } from "@const/class.constants";
import { FC } from "react";
import { useMatch } from "react-router";
import { RoutePath } from "src/data/Routes";
import NavigateRoute from "./NavigateRoute";
import { useNavProps } from "./useNavProps";

export const RouteType: FC = () => {
  const match = useMatch(RoutePath.MATCH_TYPE);
  const navProps = useNavProps(search => {
    const cls = match.params.class;
    let type = match.params.type;
    let item = match.params.item;
    if (ClassKey.STORAGE !== cls && !item) {
      item = type;
      type = null;
    }
    return { clsName: cls, allType: RoutePath.TYPE, typeOrDevice: type, itemName: item, search };
  }, [match.params]);

  return navProps && <NavigateRoute {...navProps} />;
};
